module.exports = __webpack_public_path__ + "img/image_1.14df0ac4.png";